<template>
    <div style="background-color: white; width: 100%;">
<!--        <div style="display: flex; justify-content: space-between; align-items: center; padding: 20px; background-color: #F5FAFF;">-->
<!--            <div>-->
<!--                <div style="color: #4E4E4E; font-size: 18px;">在线理赔平台</div>-->
<!--                <div style="color: #4E4E4E; font-size: 12px;">益宝-心智宝项目心智 障碍者保障平台</div>-->
<!--            </div>-->
<!--            <van-image width="151px" height="135px" :src="require('@/assets/claimHead.jpg')"/>-->
<!--        </div>-->
        <van-image width="100%" height="auto" :src="require('@/assets/claimHead.jpg')"/>
        <!--<div style="padding: 20px;">
            <div style="display: flex; justify-content: stretch;">
                <van-button color="linear-gradient(to right, #4587DD, #40B6F8)" style="flex:1; margin-right: 20px; border-radius: 6px;" @click="gotoClaim">发起理赔</van-button>
                <van-button color="linear-gradient(to right, #4587DD, #40B6F8)" style="flex:1; border-radius: 6px;" @click="claimQuery">理赔查询</van-button>
            </div>
        </div>-->
        <div style="padding: 0 20px 20px 20px;">
<!--            <van-image width="auto" height="auto" :src="require('@/assets/理赔公示.png')"/>-->
            <div style="display: flex; flex-direction: column; align-items: center; box-shadow:0px 1px 5px 0px rgba(202,218,239,1); border-radius:8px; margin-bottom: 20px;">
                <div style="display: flex; align-items: center; justify-content: center;">
                    <div style="background-color: #1C7CF8; width: 11px; height: 2px;"/>
                    <div style="color: #4E4E4E; font-size: 14px; font-weight: bolder; margin: 10px 10px;">理赔公示 保障安心</div>
                    <div style="background-color: #1C7CF8; width: 11px; height: 2px;"/>
                </div>
                <div style="color: #999999; font-size: 10px; margin-bottom: 10px;">数据截止{{date}}</div>
                <div style="width: 100%; display: flex; align-items: center; flex-direction: row; justify-content: space-around;">
                    <div style="display: flex; flex-direction: column; align-items: center;">
                        <div style="color: #FF7E46; font-size: 24px;">{{info.claimsNum}}+<span style="font-size: 14px;">人</span></div>
                        <div style="color: #999999; font-size: 10px;">理赔咨询</div>
                    </div>
                    <div style="display: flex; flex-direction: column; align-items: center;">
                        <div style="color: #FF7E46; font-size: 24px;">{{Number(info.money)}}+<span style="font-size: 14px;">元</span></div>
                        <div style="color: #999999; font-size: 10px;">累计赔付金额</div>
                    </div>
                </div>
                <div style="margin-top: 15px; border-top: 1px #F3F3F3 solid; width: 100%;">
                    <div style="padding: 20px;">
                        <div v-for="(item,index) in list" :key="index" style="display: flex; color: #999999; font-size: 12px;">
                            <div style="flex: 2;">{{item.applyName}}</div>
                            <div style="flex: 3;">{{item.applyProdName}}</div>
                            <div style="flex: 3;">{{item.applyDate|dateFormat('MM-DD')}}获赔{{item.applyAmount}}元</div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="display: flex; flex-direction: column; align-items: center; box-shadow:0px 1px 5px 0px rgba(202,218,239,1); border-radius:8px; margin-bottom: 20px;">
                <div style="display: flex; align-items: center; justify-content: center;">
                    <div style="background-color: #1C7CF8; width: 11px; height: 2px;"/>
                    <div style="color: #4E4E4E; font-size: 14px; font-weight: bolder; margin: 10px 10px;">理赔案例</div>
                    <div style="background-color: #1C7CF8; width: 11px; height: 2px;"/>
                </div>
                <van-image width="auto" height="auto" :src="type === '0' ? require('@/assets/理赔案例1.jpg') : require('@/assets/理赔案例.jpg')"/>
            </div>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';
    import {Image, Button} from 'vant';
    import moment from 'moment';
    import Cookies from 'js-cookie'

    Vue.use(Image).use(Button);
    export default {
        name: "Claim",
        data() {
            return {
                date: moment(Date()).format('YYYY年M月'),
                info: {},
                list: [],
                type: Cookies.get('type'),
            }
        },
        created() {
            this.$axios.get("/claim/claimRecord").then(res => {
                this.info = res.data
                this.list = this.info.applyClaimList.slice(0, 3)
            }).catch(err => {
                console.log(err);
            })
        },
        methods: {
            gotoClaim() {
                this.$router.push('/applyClaim')
            },
            claimQuery() {
                this.$router.push('/claimQuery')
            }
        }
    }
</script>

<style scoped>

</style>
